import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2, CalendarPlus } from "lucide-react";
import { downloadIcs } from "@/lib/ics";
import { formatDateTimeParts } from "@/lib/utils";

export default function ConfirmBooking() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("loading");
  const [apt, setApt] = useState(null);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.get("/appointments/confirm", { params: { token } })
      .then(r => { setApt(r.data.appointment); setState(r.data.already_confirmed ? "already" : "ok"); })
      .catch(e => { setMsg(e.response?.data?.detail || "Error"); setState("error"); });
  }, [params]);

  return (
    <div className="max-w-md mx-auto p-8">
      <Card><CardContent className="p-8 text-center">
        {state === "loading" && (<>
          <Loader2 size={48} className="text-blue-500 animate-spin mx-auto mb-3"/>
          <p className="text-slate-600">Confirmando tu cita…</p>
        </>)}
        {(state === "ok" || state === "already") && apt && (<>
          <CheckCircle2 size={56} className="text-emerald-500 mx-auto mb-3"/>
          <h1 className="text-2xl font-bold text-slate-900">
            {state === "already" ? "Cita ya confirmada" : "¡Cita confirmada!"}
          </h1>
          <div className="bg-blue-50 rounded-xl p-4 mt-4 text-sm text-slate-700">
            <div>Dr. <strong>{apt.doctor_name}</strong></div>
            <div>{formatDateTimeParts(apt.date, apt.time)} (Ecuador UTC-5)</div>
            <div className="text-xs text-slate-500 mt-1">{apt.clinic_name} · {apt.address}</div>
          </div>
          <Button data-testid="confirm-ics-btn"
                  onClick={() => downloadIcs({
                    title: `Cita Dr. ${apt.doctor_name}`,
                    description: `${apt.specialty || ""} · ${apt.clinic_name}`,
                    location: `${apt.address}`, date: apt.date, time: apt.time, durationMin: 30,
                  })}
                  variant="outline" className="w-full mt-4 border-blue-200 text-blue-700 hover:bg-blue-50">
            <CalendarPlus size={16} className="mr-2"/> Añadir a mi calendario
          </Button>
          <Button data-testid="confirm-home-btn" onClick={() => nav("/")} className="w-full mt-2 bg-blue-600 hover:bg-blue-700">
            Volver al inicio
          </Button>
        </>)}
        {state === "error" && (<>
          <XCircle size={56} className="text-red-500 mx-auto mb-3"/>
          <h1 className="text-xl font-bold text-slate-900">Enlace inválido</h1>
          <p className="text-slate-600 text-sm mt-2">{msg}</p>
          <Button onClick={() => nav("/buscar")} className="mt-5 bg-blue-600 hover:bg-blue-700">Reservar otra cita</Button>
        </>)}
      </CardContent></Card>
    </div>
  );
}
